import React from 'react'
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import FormLink from '../../../../library/form/components/FormLink';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormROStatus from '../../../../library/form/components/FormROStatus';

const StockCheckListPhysicalRow = (props) => {
    const { formObject, viewData, rowKey } = props;

    const renderPhysicalCount = () => {
        if (viewData.rowValues.notUsableCount1.val === '0') {
            return(
                <FormWrapper customWrapper="" wrapperClass="" formObject={formObject} rowKey={rowKey} action={{ paramName: "physicalCount" }} >
                    <span className="uiBlock uiLeftAlignText" style={{ height: "20px", fontSize: "11px" }}>
                        <span className='uiSpacerR5 uiBold'><SarasTrans value="Physical Count" /></span><FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "physicalCount" }} className="uiHighlightBlueRegular" />
                    </span>
                </FormWrapper> 
            )
        }
        else {
            return(
                <FormWrapper customWrapper="" wrapperClass="" formObject={formObject} rowKey={rowKey} action={{ paramName: "physicalCount" }} >
                    <span className="uiBlock uiLeftAlignText" style={{ height: "20px", fontSize: "11px" }}>
                        <span className='uiSpacerR5 uiBold'><SarasTrans value="Physical Count" /></span><FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "physicalCount" }} className="uiHighlightRedLineThrough" />
                    </span>
                    <span className="uiBlock uiLeftAlignText" style={{ height: "20px", fontSize: "11px" }}>
                        <span className='uiSpacerR5 uiBold'><SarasTrans value="Usable Count" /></span><FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "usableCount" }} className="uiHighlightBlueRegular" />
                    </span>
                </FormWrapper> 
            )
        }
    }

     //console.log('Material Row item',viewData.rowValues.item.valF);
    return (
        <div
            style={{
                minHeight: "310px",
                maxHeight: "310px",
                display: "flex", 
                flexDirection: "column",
                justifyContent: "space-between"
            }}
            className="uiBoxBlue uiBoxSection uiContentCenter uiBorderRoundAll uiBoxSection200"
        >
            <div>
                <div className="uiSpacer5">
                    <div className="uiBlock uiContentCenter">
                        <FormROValue format="#" formObject={formObject} className="uiSpacerH5 uiHighlightText" rowKey={rowKey} action={{ paramName: "itemId" }} />
                    </div>

                    <div style={{ margin: "3px auto", width: "100%", backgroundColor: "#fff", textAlign: "center", minHeight: "60px" }}>
                        <FormAttachment style={{ cursor: "pointer", maxWidth: "50%", maxHeight: "60px" }} formObject={formObject} rowKey={rowKey} action={{ InputType: "i", paramName: "itemImage" }} />
                    </div>

                    <FormROValue style={{ height: "20px", fontSize: "11px", overflow:"hidden" }} className="uiBlock" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "pItemId" }} />
                    <FormROValue style={{ height: "30px", fontSize: "11px", overflow:"hidden" }} className="uiBlock" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemName" }} />
                    <FormROValue style={{ fontSize: "11px", overflow:"hidden", fontWeight: "bold" }} className="uiBlock" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "profileName" }} />

                    {renderPhysicalCount()}
                    <FormWrapper customWrapper="" wrapperClass="" formObject={formObject} rowKey={rowKey} action={{ paramName: "difference" }} >
                        <span className="uiBlock uiLeftAlignText" style={{ height: "20px", fontSize: "11px" }}>
                            <span className='uiSpacerR5 uiBold'><SarasTrans value="Count Diff" /></span><FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "difference" }} />
                        </span> 
                    </FormWrapper>
                    <div>
                        <span className="uiCenterAlignText" style={{height: "20px", fontSize: "11px" }}>
                            <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} className='uiSpacerH5' />
                        </span>
                        <span className="uiCenterAlignText" style={{height: "20px", fontSize: "11px" }}>
                            <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "storeLocation" }} className='uiSpacerH5' />
                        </span>
                    </div> 
                </div>
            </div>
            <div className="uiSpacer5">
                <div>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "stockStatus" }} className='uiChip' />
                </div>
                <FormWrapper customWrapper="div" wrapperClass={"uiLineHeightButton"} formObject={formObject} rowKey={rowKey} action={{ paramName: "adjustId" }} >
                    <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "adjustId" }} value="Adjust" />
                    <FormLink formObject={formObject} rowKey={rowKey} className="uiLink uiSpacerH5"
                        action={{paramName: "adjustId"}}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                    <FormROStatus compactMode={1} formObject={formObject} rowKey={rowKey} action={{ paramName: "adjustStatus" }} className='uiSpacerH5' />
                </FormWrapper>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    className="" 
                    action={{ actionId: "edit", paramName: "editBtn", actionParam: { pathKey: "counting" }, containerKey: "popup" }}
                ></FormButton>
                <FormButton formObject={formObject} rowKey={rowKey} confirm="Are you sure to Mark Item as Pending Count?"
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    className=""
                    action={{ actionId: "refresh", refreshMode:"self", paramName: "delBtn", actionParam: {actionType:"requestMarkDelete"}, containerKey: "popup" }}
                ></FormButton>
            </div>
        </div>
    )
}

export default StockCheckListPhysicalRow
